import Axios from "axios";
import { ApiBaseUrl, DropDownUrl, SupplierUser } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  AllStoresAndBranchesRequest,
  AllStoresAndBranchesResponse,
  AssignBranchAccessRequest,
  BranchAndStoreAccessResponse,
  CloseBranchAccessRequest,
  GetASupplierUserResponse,
  GetSupplierBranchUserRequest,
  GetSupplierBranchUserResponse,
  SupplierBranchUserEditRequest,
  SupplierBranchUserFilter,
  SupplierBranchUserForGetASupplierUserRequest,
  SupplierBranchUserRequest,
} from "../models/supplierUserBarnch.model";

export const CreateSupplierBranchUser = async (
  data: SupplierBranchUserRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUser + "/AddSupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const EditSupplierBranchUser = async (
  data: SupplierBranchUserEditRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUser + "/EditSupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const DeleteSupplierBranchUser = async (
  data: SupplierBranchUserForGetASupplierUserRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUser + "/DeleteSupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetSupplierBranchUser = async (
  data: GetSupplierBranchUserRequest
): Promise<ApiResultModel<GetSupplierBranchUserResponse[]>> => {
  return await Axios.post<ApiResultModel<GetSupplierBranchUserResponse[]>>(
    ApiBaseUrl + SupplierUser + "/GetSupplierUserList",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetSupplierUserListReportExcel = async (
  data: SupplierBranchUserFilter
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SupplierUser + "/GetSupplierUserListReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست کاربران شعبه"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetASupplierUser = async (
  data: SupplierBranchUserForGetASupplierUserRequest
): Promise<GetASupplierUserResponse> => {
  return await Axios.post<ApiResultModel<GetASupplierUserResponse>>(
    ApiBaseUrl + SupplierUser + "/GetASupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetBranchAndStoreAccess = async (
  data: SupplierBranchUserForGetASupplierUserRequest
): Promise<BranchAndStoreAccessResponse[]> => {
  return await Axios.post<ApiResultModel<BranchAndStoreAccessResponse[]>>(
    ApiBaseUrl + SupplierUser + "/GetBranchAndStoreAccessById",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteCloseBranchAccess = async (
  data: CloseBranchAccessRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUser + "/CloseBranchAccess",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AssignBranchAccess = async (
  data: AssignBranchAccessRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUser + "/AssignBranchAccess",
    data
  ).then((result) => {
    return result.data.data;
  });
};
